@if (event(); as event) {
    <div
        [cdkContextMenuTriggerFor]="contextMenu"
        (cdkContextMenuOpened)="isContextOpen.set(true)"
        (cdkContextMenuClosed)="isContextOpen.set(false)"
        [style]="{
            'background-color': isHex()! ? currentColor() : '',
        }"
        [attr.data-color]="isHex()! ? '' : currentColor()"
        [style.text-decoration]="isCanceled() ? 'line-through' : 'none'"
        class="event truncate"
    >
        <!-- color가 hex 코드인 경우에만 배경색을 적용합니다. -->
        <!-- hex 코드가 아닌 경우 scss에서 정의한 색상을 적용합니다. -->
        <div
            class="prefix"
            [attr.data-all-day]="event.allDay"
            [style]="{
                'background-color': isHex()! ? event.color : '',
            }"
            [attr.data-color]="isHex()! ? '' : event.color"
            [class.active]="isContextOpen()"
        ></div>
        <p timelineEventContent [event]="event"></p>
    </div>
}

<ng-template #contextMenu>
    @if (menus() && menus().length > 0) {
        <app-menu cdkMenu>
            @for (option of menus(); track $index) {
                <app-menu-option
                    (click)="menu.emit(option.value)"
                    cdkMenuItem
                    [icon]="option.icon"
                    >{{ option.label }}</app-menu-option
                >
            }
        </app-menu>
    }
</ng-template>
